module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/shopping-cart/shopping-cart.component.css
// module id = ./src/app/pages/shopping-cart/shopping-cart.component.css
// module chunks = main